module.exports = __webpack_public_path__ + "static/img/img-iccid.dbbc8d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/img-iccid.jpg
// module id = 88Sx
// module chunks = 1